import React from 'react';
import { AppRoutes } from 'src/lib/routes';
import CopySvg from 'public/images/svg_icons/copy.svg';
import FacebookSvg from 'public/images/svg_icons/facebook.svg';
import WhatsappSvg from 'public/images/svg_icons/whatsapp.svg';
import Link from 'next/link';
import { humanizeMoney } from 'src/helpers';
import Copyable from 'src/components/Copyable';
import { REFERRAL_AMOUNT, REFERRAL_PAYOUT_AMOUNT } from 'src/lib/constants'

const sharingMessage = (amount: string, referralUrl: string) =>
  `Hi! Here’s ${amount} off your next trip! With Seek Sophie, you can support awesome local businesses through your travels, I think you’ll like it! Find out more at ${referralUrl}`;

type Props = {
  containerClass?: string;
  hideSlogan?: boolean;
  referralCode?: string;
  linkModifierClass?: string;
  iconBgClass?: string;
};

const ReferralIntro: React.FC<Props> = ({
  containerClass = 'tw-bg-yellow-lightest px-2 px-md-32 py-4 py-md-32',
  hideSlogan,
  referralCode,
  linkModifierClass,
  iconBgClass,
}) => {
  return (
    <div>
      {referralCode ? (
        <>
          <div className="md:tw-px-10">
            <div className="tw-bg-white tw-border tw-border-grey-lighter tw-rounded-4xl tw-px-3 tw-py-2.5 tw-flex tw-items-center tw-justify-between">
              <input
                readOnly
                value={AppRoutes.inviteRoute({}, { code: referralCode }).toUrl()}
                type="text"
                className="tw-appearance-none tw-outline-none tw-flex-grow tw-text-brand-navy tw-placeholder-brand-navy"
              />
              <Copyable as="div" className="tw-cursor-pointer" copyContent={AppRoutes.inviteRoute({}, { code: referralCode }).toUrl()}>
                <CopySvg width={24} height={24} className="tw-text-orange tw-ml-2" />
              </Copyable>
            </div>
          </div>

          <div className={`tw-flex tw-items-center tw-justify-center tw-mt-8`}>
            <div className="tw-font-semibold tw-mr-4 tw-font-styleSans tw-text-sm md:tw-text-base">share this link:</div>
            <div>
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                  AppRoutes.inviteRoute({}, { code: referralCode }).toUrl()
                )}`}
                target="_blank"
                rel="noreferrer noopener"
              >
                <FacebookSvg width={24} height={24} className="tw-text-brand-navy tw-mr-2" />
              </a>

              <a
                href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
                  sharingMessage(
                    humanizeMoney(REFERRAL_AMOUNT),
                    AppRoutes.inviteRoute({}, { code: referralCode }).toUrl()
                  )
                )}`}
                target="_blank"
                rel="noreferrer noopener"
              >
                <WhatsappSvg width={24} height={24} className="tw-text-brand-navy" />
              </a>
            </div>
          </div>
        </>
      ) : (
        <div className="tw-text-center">
          <Link legacyBehavior prefetch={false} href={AppRoutes.accountReferralRoute().toPath()}>
            <a className="btn btn-primary">Start Sharing</a>
          </Link>
        </div>
      )}
    </div>
  );
};

export default ReferralIntro;
